import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query/react";
import { riskSurfaceApi } from "../services/riskSurface";
import { routingApi } from "../services/routing";
import { surfaceSlice } from "../features/surface/surfaceSlice";
import { riskViewerSlice } from "../features/riskViewer/riskViewerSlice";
import { mapDisplaySlice } from "../features/mapDisplay/mapDisplaySlice";
import { playbackSlice } from "../features/time/playbackSlice";
import { timelineSlice } from "../features/time/TimelineSlice";
import { drawerSlice } from "../features/Drawer/drawerSlice";
import { pageWidthSlice } from "../features/pageWidth/pageWidthSlice";
import { userViewOverrideSlice } from "../features/riskViewer/userViewOverrideSlice";
import { alertDisplaySlice } from "../features/alertDisplay/alertDisplaySlice";

const store = configureStore( {
    reducer: {
        [riskSurfaceApi.reducerPath]: riskSurfaceApi.reducer,
        [routingApi.reducerPath]: routingApi.reducer,
        mapDisplay: mapDisplaySlice.reducer,
        playback: playbackSlice.reducer,
        timeline: timelineSlice.reducer,
        pageWidth: pageWidthSlice.reducer,
        riskViewer: riskViewerSlice.reducer,
        userViewOverride: userViewOverrideSlice.reducer,
        surface: surfaceSlice.reducer,
        drawer: drawerSlice.reducer,
        alertDisplay: alertDisplaySlice.reducer,
    },
    middleware: ( getDefaultMiddleware ) => getDefaultMiddleware( {
        // the large geojson objects in the store cause these checks to be very time consuming, performance is better when disabled
        immutableCheck: false,
        serializableCheck: false,
    } ).concat( riskSurfaceApi.middleware, routingApi.middleware ),
} );

setupListeners( store.dispatch );

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
